import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';

import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { CircularProgress, Button, Grid, Paper, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Delete from '@mui/icons-material/Delete';

import AbEnvironment from '../auth/AbEnvironment';
import Address from '../ui/Address'

import BusinessBeneficialOwnerUpdateMutation from './BusinessBeneficialOwnerUpdateMutation';
import BusinessBeneficialOwnerDeleteMutation from './BusinessBeneficialOwnerDeleteMutation';
import ConfirmationDialog from '../ui/ConfirmationDialog';
import PageTitle from '../ui/PageTitle';
import CountrySelect from '../ui/CountrySelect'

import CheckCircle from '@mui/icons-material/CheckCircle';
//import PauseCircleFilled from '@mui/icons-material/PauseCircleFilled';
import HourglassEmpty from '@mui/icons-material/HourglassEmpty';
import HelpOutline from '@mui/icons-material/HelpOutline';
import { ZoomIn } from '@mui/icons-material';

import SaveButton from '../ui/SaveButton';
import AppBindStyles from '../../AppBindStyles';
import LoadingSpinner from '../ui/LoadingSpinner';
import SavingSpinner from '../ui/SavingSpinner';
import ServerError from '../ui/ServerError';

import { green, amber } from '@mui/material/colors';
import { differenceInYears, format, subYears } from 'date-fns';

const abEnvironment = new AbEnvironment();
const BusinessBeneficialOwnerEditQuery = graphql`
query BusinessBeneficialOwnerEditQuery($boId: UUID!) {
  beneficialOwnerTByBoId(boId: $boId) {   
    ssn
    dateOfBirth
    passportNumber
    passportCountry
    lastName
    firstName
    address1 
    address2 
    city
    state
    country
    postalCode
    dwollaId
    beneficialOwnerDocTsByBoId {
      totalCount
      nodes {
        bodId
        dwollaId
        dwollaStatus
        documentType
        created
      }
    }

    businessIdentityTByBiId {
      biId
      accountTByAccountId {
        dwollaCid
      }
    }
  }
}
`;
const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },
    success: {
      backgroundColor: green[300],
    },
    error: {
      backgroundColor: theme.palette.error.light,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
    close: {
      padding: theme.spacing(0.5),
    },
    select: {
      marginLeft: -8,
      marginTop: -8,
    },
    dateField: {
      width: 160,
    },
    businessClassification: {
      margin: theme.spacing(1),
    },
    [theme.breakpoints.up('xs')]: {
      tableCellPadding: {
        paddingLeft: `6px`,
        paddingRight: `14px`,
      }
    },
    [theme.breakpoints.up('sm')]: {
        tableCellPadding: {
        paddingLeft: `12px`,
        paddingRight: `28px`,
      }
    },
    [theme.breakpoints.up('md')]: {
      
      tableCellPadding: {
        paddingLeft: `24px`,
        paddingRight: `56px`,
      }
    },
  
    tblHead: {
      backgroundColor: '#f1f1f1'
    },
});

class BusinessBeneficialOwnerEdit extends Component {
    state = {
        showSpinner: false,
        showSecondarySpinner: false,
        saveStatus: null,
        saveMessage: null,
        snackbarOpen: false,
        confirmDelete: false,
        confirmSend: false,    
        forceFetch: 0,

        dwollaFetchDone: false,

        lastName: null,
        firstName: null,
        
        dateOfBirth: null,
        ssn: null,

        address1: null,
        address2: null,
        city: null,
        state: null,
        country: null,
        postalCode: null,

        passportNumber: null,
        passportCountry: null,
        dwollaStatus: null,
        ageError: null
    }

    componentDidMount() {
     this.getDwollaBeneficialOwner();

     let success = localStorage.getItem('vsuccess');
     //if success have a value, it means coming from business entity or document upload and we need to show message
     if (success && success === 'ss') {
       this.setState({ saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'Save successful.', saveSnackbarDuration: 3000 });
     } else if (success && success === 'pn') {
       this.setState({ saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'Partner notified.', saveSnackbarDuration: 3000 });
     } else if (success && success === 'du') {
       this.setState({ saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'Document uploaded.', saveSnackbarDuration: 3000 });
     } 
     localStorage.removeItem('vsuccess');

    }

    getDwollaBeneficialOwner() {
      const { callPartnerApi, logError } = this.props.auth;
   
      let aPjwt = abEnvironment.getPjwt();
      const params = new URLSearchParams(this.props.location.search);
      let dwollaId = params.get('dId');

      if (dwollaId) {
        // Call server side to get status of this beneficial owner.
        let payload = {
          operation: "getDwollaBeneficialOwner",
          params: {
            pJwt:      aPjwt,
            dwollaOwnerId: dwollaId
          }
        };
    
        callPartnerApi('appbind/generic',
                      'POST',
                      payload
        ).then(resp => {
          return resp.json();
        }).then(data => {

          this.setState({dwollaFetchDone: true, dwollaStatus: data.body.verificationStatus})       

        }).catch(reason => {
          this.setState({dwollaFetchDone: true});      
          logError('Exception in BeneficialOwnerEdit.js: ' + reason);
        });      

      } else {
        this.setState({dwollaFetchDone: true});
      }


    }

    goBack() {
      this.props.history.goBack();
    }
    
    goTo(route) {
      this.props.history.replace(`/${route}`);
    }


    replaceRoute(route) {
      this.props.history.replace(`/${route}`);
    }

    goToDocumentDetail = (bodId, dwollaId) => {
      let url = 'documentviewer?bodId=' + bodId + '&dId=' + dwollaId;
      this.props.history.push(`/${url}`);
    }

    goToDocumentUpload = (biId, boId) => {
      let url = 'documentupload?biId=' + biId + '&boId=' + boId + '&type=bo';
      this.props.history.push(`/${url}`);
  
    }


    getValueForRender(state_member, prop_member, theDefault)
    {
       if (state_member != null)
        return state_member;
      
      if (prop_member != null)
        return prop_member;
  
      return theDefault;
    }


    showSpinner() {
        return this.state.showSpinner;
    }

    showSecondarySpinner() {
      return this.state.showSecondarySpinner;
    }


    disableSave(renderProps) {

      if (renderProps === null || renderProps.beneficialOwnerTByBoId === null)
        return true;

      let retval = this.disableAttributeCheck(this.state.ssn, renderProps.beneficialOwnerTByBoId.ssn) &&
                   this.disableAttributeCheck(this.state.dateOfBirth, renderProps.beneficialOwnerTByBoId.dateOfBirth) &&
                   this.disableAttributeCheck(this.state.passportNumber, renderProps.beneficialOwnerTByBoId.passportNumber) &&
                   this.disableAttributeCheck(this.state.passportCountry, renderProps.beneficialOwnerTByBoId.passportCountry) &&
                   this.disableAttributeCheck(this.state.lastName, renderProps.beneficialOwnerTByBoId.lastName) &&
                   this.disableAttributeCheck(this.state.firstName, renderProps.beneficialOwnerTByBoId.firstName) &&
                   this.disableAttributeCheck(this.state.address1, renderProps.beneficialOwnerTByBoId.address1) &&
                   this.disableAttributeCheck(this.state.address2, renderProps.beneficialOwnerTByBoId.address2) &&
                   this.disableAttributeCheck(this.state.city, renderProps.beneficialOwnerTByBoId.city) &&
                   this.disableAttributeCheck(this.state.state, renderProps.beneficialOwnerTByBoId.state) &&
                   this.disableAttributeCheck(this.state.country, renderProps.beneficialOwnerTByBoId.country) &&
                   this.disableAttributeCheck(this.state.postalCode, renderProps.beneficialOwnerTByBoId.postalCode);

      //make sure user did not blank out anything required
      if (this.getValueForRender(this.state.country, renderProps.beneficialOwnerTByBoId.country, null) === "US") {
        if (this.state.ssn === '') {
           return true;
        }

        //validate ein is 9
        var re = /^\d{9}$/;
        if (!re.test(this.state.ssn)) {
          return true;
        }
        
      }

      if (this.state.dateOfBirth === '')
        return true;
       
      if (this.state.lastName === '')
        return true;

      if (this.state.firstName === '')
        return true;

      if (this.state.address1 === '')
        return true;

      if (this.state.city === '')
        return true;

      if (this.state.state === '')
        return true;

      if (this.state.country === '')
        return true;

      if (this.state.postalCode === '')
        return true;

      const age = differenceInYears(new Date(), new Date(this.getValueForRender(this.state.dateOfBirth, renderProps.beneficialOwnerTByBoId.dateOfBirth, null)));
      if (age < 18) {
        return true;
      }

      if (this.getValueForRender(this.state.country, renderProps.beneficialOwnerTByBoId.country, null) !== "US") {
        if (this.getValueForRender(this.state.passportCountry, renderProps.beneficialOwnerTByBoId.passportCountry, null) === null) {
          return true;
        }
        if (this.getValueForRender(this.state.passportNumber, renderProps.beneficialOwnerTByBoId.passportNumber, null) === null) {
          return true;
        }        
      }
      return retval;
    }

    disableAttributeCheck(stateVar, propsVar)
    {
        if (stateVar !== null)
        {
            if (propsVar === null && stateVar === '')
                return true;
            
            if (propsVar !== stateVar)
                return false;
        }
        return true;
    }
 
    setCountry    = (country)    => { this.setState({country:    country}); }  
    setRegion     = (region)     => { this.setState({state:      region}); }  
    setCity       = (city)       => { this.setState({city:       city}); }  
    setPostalCode = (postalCode) => { this.setState({postalCode: postalCode}); }  
    setAddress1   = (address1)   => { this.setState({address1:   address1}); }  
    setAddress2   = (address2)   => { this.setState({address2:   address2}); }  
    setPassportCountry    = (country)    => { this.setState({passportCountry:    country}); }  

    sendDwollaInfo = (boId, dwollaCid, dwollaOwnerId, props, biId) => {
      
      //alert(boId);
      if (!dwollaOwnerId) {
        this.sendDwollaInfoNew(boId, dwollaCid, props, biId);
      } else {
        this.sendDwollaInfoExisting(boId, dwollaOwnerId, props, biId);
      }
      

    }

    sendDwollaInfoExisting = (boId, dwollaOwnerId, props, biId) => {

      this.setState({ showSecondarySpinner: true });
      const { callPartnerApi } = this.props.auth;
      let aPjwt = abEnvironment.getPjwt();

      let payload =  {
          operation: "updateDwollaBeneficialOwner",
          params: {
            pJwt: aPjwt,
            dwollaOwnerId: dwollaOwnerId,
            requestBody: this.getRequestBodyForBeneficialOwner(props)
          }
        }
      
      callPartnerApi('appbind/generic',
                      'POST',
                      payload
      )
      .then((response) => {
        return response.json();
      })  
    .then(response => {

        if (response.err) {
          if (response.err.status === 404) {
            throw new Error('Error occurred notifying our partner, please contact AppBind support');
          }
          //if this happens it is an error trapped by dwolla either new or that we don't trap for - lets show it.
          let errorMsg = response.err.body._embedded.errors[0].message;
          throw (errorMsg);
        }

        localStorage.setItem('vsuccess', 'pn')
        let url = 'businessbeneficialowneredit?boId=' + boId + '&dId=' + dwollaOwnerId;
        this.replaceRoute(url);
        window.location.reload();

      })
      .catch(error => {
        let errMsg = error;
        if (!errMsg || errMsg === '') {
          errMsg = 'Problem notifying our ACH partner.';
        }

        this.setState({ showSecondarySpinner: false, saveSnackbarOpen: true, saveStatus: 'error', saveMessage: errMsg, saveSnackbarDuration: null  });
      });

    }


    sendDwollaInfoNew = (boId, dwollaCid, props, biId) => {

      this.setState({ showSecondarySpinner: true });
      const { callPartnerApi } = this.props.auth;
      let aPjwt = abEnvironment.getPjwt();
      let dwollaId = null;

      let payload = {
          operation: "createDwollaBeneficialOwner",
          params: {
            pJwt: aPjwt,
            dwollaCId: dwollaCid,
            requestBody: this.getRequestBodyForBeneficialOwner(props)
          }
      }

      callPartnerApi('appbind/generic',
                      'POST',
                      payload
      )
      .then((response) => {
        return response.json();
      })  
      .then(response => {

        //console.log(JSON.stringify(response));
        if (response.err) {
          if (response.err.status === 404) {
            throw new Error('Error occurred notifying our partner, please contact AppBind support');
          }
          //if this happens it is an error trapped by dwolla either new or that we don't trap for - lets show it.
          let errorMsg = response.err.body._embedded.errors[0].message;
          throw (errorMsg);
        }

        dwollaId = response.id;

        BusinessBeneficialOwnerUpdateMutation.commit(boId, null, null, null, null,
          null, null, null, null, null, null, null, null, dwollaId);
  

       })
      .then(response => {
        localStorage.setItem('vsuccess', 'pn')
        let url = 'businessbeneficialowneredit?boId=' + boId + '&dId=' + dwollaId;
        this.replaceRoute(url);
        window.location.reload();
 
      })
      .catch(error => {
        //console.log(error);
        let errMsg = error;
        if (!errMsg || errMsg === '') {
          errMsg = 'Problem notifying our partner.';
        }

        this.setState({ showSecondarySpinner: false, saveSnackbarOpen: true, saveStatus: 'error', saveMessage: errMsg, saveSnackbarDuration: null  });
      });

    }



    getRequestBodyForBeneficialOwner = (props) => {

      var requestBody = {};

      //note - an entity must be saved which is why getValueForRender not needed.
      requestBody.firstName = props.beneficialOwnerTByBoId.firstName;
      requestBody.lastName = props.beneficialOwnerTByBoId.lastName;
      requestBody.email = props.beneficialOwnerTByBoId.email;
      if (props.beneficialOwnerTByBoId.ssn) {
        requestBody.ssn = props.beneficialOwnerTByBoId.ssn;
      }
      requestBody.dateOfBirth = props.beneficialOwnerTByBoId.dateOfBirth;
      
      requestBody.address = {};
      requestBody.address.address1 = props.beneficialOwnerTByBoId.address1;
      if (props.beneficialOwnerTByBoId.address2) {
        requestBody.address.address2 = props.beneficialOwnerTByBoId.address2;
      }
      requestBody.address.city = props.beneficialOwnerTByBoId.city;
      requestBody.address.stateProvinceRegion = props.beneficialOwnerTByBoId.state;
      requestBody.address.postalCode = props.beneficialOwnerTByBoId.postalCode;
      requestBody.address.country = props.beneficialOwnerTByBoId.country;

      if (props.beneficialOwnerTByBoId.passportNumber || props.beneficialOwnerTByBoId.passportCountry) {
        requestBody.passport = {};
        requestBody.passport.number = props.beneficialOwnerTByBoId.passportNumber;
        requestBody.passport.country = props.beneficialOwnerTByBoId.passportCountry;
      }

      return requestBody;
    }
   

    render() {
        const { isAuthenticated, isAuthenticatedReseller, needAssent, logError } = this.props.auth;
        const classes = this.props.classes;
        const statusOk = green[300];
        const statusWaiting = amber[400];
    

        if (!isAuthenticated() || needAssent()) {
          return (
            <Redirect to='/home' />
          );
        } else if (isAuthenticatedReseller()) {


          const params = new URLSearchParams(this.props.location.search);
          let boId = params.get('boId');
          let regionLabel = "Region";

          return (
            <QueryRenderer
              environment={abEnvironment.getEnvironment()}
              query={BusinessBeneficialOwnerEditQuery}
              variables={{boId: boId, forceFetch: this.state.forceFetch}}
              render={({error, props})=> {
                if (error) {
                  logError(error.message);
                  return (
                    <ServerError/>
                  );
                } else if (props) {

                  if (!this.state.dwollaFetchDone) { 

                    return (
                      <div className={classes.root}>
                        <Grid container direction="column" justifyContent="center">
                          <Grid item>
                            <Grid container spacing={0} direction="row" justifyContent="center" className={classes.spinny}>
                              <Grid item>
                                <CircularProgress color="primary" size={75} thickness={2}/>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </div>
                    );
            
                  } else {
      

                    let address = {
                      country:    this.getValueForRender(this.state.country,      props.beneficialOwnerTByBoId.country, ''),
                      state:      this.getValueForRender(this.state.state,        props.beneficialOwnerTByBoId.state, ''),
                      city:       this.getValueForRender(this.state.city,         props.beneficialOwnerTByBoId.city, ''),
                      postalCode: this.getValueForRender(this.state.postalCode,   props.beneficialOwnerTByBoId.postalCode, ''),
                      address1:   this.getValueForRender(this.state.address1,     props.beneficialOwnerTByBoId.address1, ''),
                      address2:   this.getValueForRender(this.state.address2,     props.beneficialOwnerTByBoId.address2, '')
                    };

                    let biId = props.beneficialOwnerTByBoId.businessIdentityTByBiId.biId;
                    let dwollaCid = props.beneficialOwnerTByBoId.businessIdentityTByBiId.accountTByAccountId.dwollaCid;
                    let dwollaOwnerid = props.beneficialOwnerTByBoId.dwollaId;

                    let uploadDwollaAllowed = true;
                    let sendDwollaAllowed = true;

                    let verificationStatus = null;
                    let noChange = false;
                    let uploadInstructions = '';
                    if (this.state.dwollaStatus) {
                      if (this.state.dwollaStatus === 'verified') {
                        verificationStatus = 'Verified';
                        noChange = true;
                        uploadDwollaAllowed = false;
                        sendDwollaAllowed = false;
                      }
                      if (this.state.dwollaStatus === 'document') {
                        sendDwollaAllowed = false;
                        verificationStatus = 'Need documentation';
                        if (this.state.country === 'US') {
                          uploadInstructions = 'Please upload a color image of your state issued drivers license or equivalent.'
                        } else {
                          uploadInstructions = 'Please upload a color image of your passport or equivalent.'

                        }
                      }
                      if (this.state.dwollaStatus === 'incomplete') {
                        //I don't think we should ever see this because we validate?
                        verificationStatus = 'Incomplete';
                      }
                      
                    } else {
                      //not submitted to Dwolla yet....cannot upload documents
                      uploadDwollaAllowed = false;
                    }

                    if (props.beneficialOwnerTByBoId.beneficialOwnerDocTsByBoId.totalCount !== 0) {
                      //make sure if a document has been submitted, they are all failed before allowing another document
                      for (var i = 0; i < props.beneficialOwnerTByBoId.beneficialOwnerDocTsByBoId.totalCount; i++) {
                        var doc = props.beneficialOwnerTByBoId.beneficialOwnerDocTsByBoId.nodes[i];
                        if (doc.dwollaStatus === "pending" || doc.dwollaStatus === 'Approved') {
                          uploadDwollaAllowed = false;
                        }
                      }
                    }
                    
                    // Determine the maximum date.  So 18 years ago
                    let theMaxDate = subYears(new Date(), 18);

                    let ssnErrorText = '';
                    if (this.getValueForRender(this.state.ssn, props.beneficialOwnerTByBoId.ssn, null) !== null) {
                      let ssn = this.getValueForRender(this.state.ssn, props.beneficialOwnerTByBoId.ssn, null);
                      //validate ein is 9
                      var re = /^\d{9}$/;
                      if (ssn && !re.test(ssn)) {
                        ssnErrorText = 'SSN must be 9 numbers no dashes'
                      }
                    }
            
                    //see if there are any failed documents.  If there are, a link is presented to take them to a new page.
                    var failedDocuments = false;
                    if (props.beneficialOwnerTByBoId.beneficialOwnerDocTsByBoId.totalCount > 0) {
                      for (var y = 0; y < props.beneficialOwnerTByBoId.beneficialOwnerDocTsByBoId.totalCount; y++) {
                        var tempDoc = props.beneficialOwnerTByBoId.beneficialOwnerDocTsByBoId.nodes[y];
                        if (tempDoc.dwollaStatus === 'Failed Approval') {
                          failedDocuments = true;
                          break;
                        }
                      }
                    }


                    let maskedSSN = '';
                    if (noChange) {
                      let temp = this.getValueForRender(this.state.ssn, props.beneficialOwnerTByBoId.ssn, '');
                      if (temp === '') {
                        maskedSSN = '';
                      } else {
                        maskedSSN = '***-**-' + temp.substring(temp.length - 4, temp.length);
                      }
                    }

                    return (
                      <div id="beneficial-owner-edit" className={classes.root}>
                        <PageTitle title="Edit beneficial business owner" subtitle="Person with more than 25% stake." showBackButton={true} name="Business Entity" history={this.props.history}/>
      
                        <Paper className={classes.paper}>
                          <Grid container spacing={2} direction="row" justifyContent="flex-start">

                          {verificationStatus &&
                          <Grid item xs={12}>
                              <Grid container alignItems="center">
                          
                                <Grid item>
                                  <TextField 
                                    id="status" label="Verification status"
                                    value={  verificationStatus}
                                    InputProps={{ readOnly: true, disableUnderline: true }}
                                  />
                                </Grid>
                                <Grid item>
                                  {(this.state.dwollaStatus === 'verified') &&
                                    <CheckCircle htmlColor={statusOk} style={{verticalAlign: "-20"}}/>
                                  }
                                  {(this.state.dwollaStatus === 'document') &&
                                    <Tooltip title={uploadInstructions}>
                                      <HourglassEmpty htmlColor={statusWaiting}  style={{verticalAlign: "-20"}}/>
                                    </Tooltip>
                                  }
                                </Grid>
                              </Grid>
                            </Grid>
                          }                     
                          <Grid item xs={12} sm={6}>
                              <TextField  data-recording-ignore="mask"
                                id="first-name" label="First name *"
                                value={  this.getValueForRender(this.state.firstName, props.beneficialOwnerTByBoId.firstName, '')}
                                onChange={ (e) => this.setState({ firstName: e.target.value }) }
                                inputProps={{ maxLength: 32 }}
                                InputProps={{ readOnly: noChange, disableUnderline: noChange }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField  data-recording-ignore="mask"
                                id="last-name" label="Last name *"
                                value={  this.getValueForRender(this.state.lastName, props.beneficialOwnerTByBoId.lastName, '')}
                                onChange={ (e) => this.setState({ lastName: e.target.value }) }
                                inputProps={{ maxLength: 32 }}
                                InputProps={{ readOnly: noChange, disableUnderline: noChange }}
                              />
                            </Grid>
                            
                            <Grid item xs={12} sm={6}>
                              <div style={AppBindStyles.datePickerField}>
                              <DatePicker data-recording-ignore="mask"
                                autoOk
                                  label="Date of birth *"
                                  value={this.getValueForRender(this.state.dateOfBirth, props.beneficialOwnerTByBoId.dateOfBirth, null)}
                                  onChange={(date) => this.setState({ dateOfBirth: date }) }
                                  className={classes.dateField}
                                  format="YYYY-MM-DD"
                                  maxDate={theMaxDate}
                                  maxDateMessage="Business owner must be over 18"
                                  InputProps={{ readOnly: noChange, disableUnderline: noChange }}
                                  renderInput={(params) => <TextField {...params} />}
                                />
                              </div>
                            </Grid>
                            {!noChange &&
                            <Grid item xs={12} sm={6}>
                              <TextField data-recording-ignore="mask"
                              id="ssn" label={"SSN (9 digits no dashes)" + ((this.getValueForRender(this.state.country, props.beneficialOwnerTByBoId.country, '') === "US") ? " *"  : "")}
                              value={  this.getValueForRender(this.state.ssn, props.beneficialOwnerTByBoId.ssn, '') }
                              onChange={ (e) => this.setState({ ssn: e.target.value }) }
                              inputProps={{ maxLength: 9 }}
                              error={ssnErrorText !== ''}
                              helperText={ssnErrorText}
                              InputProps={{ readOnly: noChange, disableUnderline: noChange }}
                              />
                            </Grid>
                            }
                            {noChange &&
                            <Grid item xs={12} sm={6}>
                              <TextField data-recording-ignore="mask"
                              id="ssn" label={"SSN (9 digits no dashes)" + ((this.getValueForRender(this.state.country, props.beneficialOwnerTByBoId.country, '') === "US") ? " *"  : "")}
                              value={  maskedSSN }
                              inputProps={{ maxLength: 9 }}
                              InputProps={{ readOnly: noChange, disableUnderline: noChange }}
                              />
                            </Grid>
                            }
                            <Grid item xs={12}>
                              <Address
                                showRequired={true}
                                address={address}
                                displayOnly={noChange}
                                regionLabel={regionLabel}
                                setCountryCodeState={this.setCountry}
                                setRegionCodeState={this.setRegion}
                                setCityState={this.setCity}
                                setPostalCodeState={this.setPostalCode}
                                setAddress1State={this.setAddress1}
                                setAddress2State={this.setAddress2}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField data-recording-ignore="mask"
                                id="ppnumber" label={"Passport number" + ((this.getValueForRender(this.state.country, props.beneficialOwnerTByBoId.country, '') !== "US") ? " *"  : "")}
                                value={ this.getValueForRender(this.state.passportNumber, props.beneficialOwnerTByBoId.passportNumber, '') }
                                onChange={ (e) => this.setState({ passportNumber: e.target.value }) }
                                InputProps={{ readOnly: noChange, disableUnderline: noChange }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                              <div className={classes.select}>
                                <CountrySelect data-recording-ignore="mask"
                                  overrideLabel={"Passport country"}
                                  displayOnly={noChange}
                                  showRequired={this.getValueForRender(this.state.country, props.beneficialOwnerTByBoId.country, '') !== "US"}
                                  countryCode={this.getValueForRender(this.state.passportCountry, props.beneficialOwnerTByBoId.passportCountry, '')}
                                  setCountryCodeState={this.setPassportCountry}
                                  
                                />
                              </div>
                            </Grid>
          
                            {props.beneficialOwnerTByBoId.beneficialOwnerDocTsByBoId.totalCount > 0 &&
                            <React.Fragment>
                              <Grid item xs={12}>
                                <Grid container spacing={1} alignItems="center">
                                  <Grid item>
                                    <Typography variant="h6" style={AppBindStyles.sectionTitleTable}>
                                      Documents uploaded
                                    </Typography>
                                  </Grid>
                                  <Grid item>
                                    <Tooltip placement='right' title='Our ACH provider requires 1 document and they are usually reviewed in 1-2 business days.  If the document uploaded does not transmit or the correct type, they may require more than one.'>
                                        <HelpOutline fontSize="small"  style={{verticalAlign: "-22"}}/>
                                    </Tooltip>
                                  </Grid>
                                </Grid>
                              </Grid>

                              <Grid item xs={12}>
                                <TableContainer>
                                    <Table>
                                      <TableHead className={classes.tblHead}>
                                        <TableRow>
                                          <TableCell className={classes.tableCellPadding}>Document type</TableCell>
                                          <TableCell className={classes.tableCellPadding}>Date uploaded</TableCell>
                                          <TableCell className={classes.tableCellPadding}>Status</TableCell>
                                          {failedDocuments &&
                                          <TableCell className={classes.tableCellPadding}>Details</TableCell>
                                          }
                                      </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {props.beneficialOwnerTByBoId.beneficialOwnerDocTsByBoId.nodes.map(n => {

                                          var documentType = '';
                                          if (n.documentType === 0) {
                                            documentType = 'Drivers license';
                                          } else if (n.documentType === 1) {
                                            documentType = 'Passport'
                                          } else if (n.documentType === 2) {
                                            documentType = 'Other government issued id'
                                          }

                                          // created time is of format: 2020-06-10 20:42:52.900848 (without Z)
                                          let created = format(new Date(n.created+'Z'), 'yyyy-MM-dd pp');
                                          
                                          return(
                                            <TableRow key={n.bodId}>
                                              <TableCell className={classes.tableCellPadding}>{documentType}</TableCell>
                                              <TableCell className={classes.tableCellPadding}>{created}</TableCell>
                                              <TableCell className={classes.tableCellPadding}>{n.dwollaStatus}</TableCell>
                                              {failedDocuments && (n.dwollaStatus === 'Failed Approval') &&
                                              <TableCell className={classes.tableCellPadding}>
                                                <Button
                                                    className={classes.iconbutton}
                                                    color="primary"
                                                    onClick={() => {
                                                      this.goToDocumentDetail(n.bodId, n.dwollaId)
                                                      }}>
                                                  <ZoomIn className={classes.detailIcon}/>
                                                </Button>
                                              </TableCell>
                                              }
                                              {failedDocuments && (n.dwollaStatus !== 'Failed Approval') &&
                                              <TableCell className={classes.tableCellPadding}>
                                              </TableCell>
                                              }

                                            </TableRow>
                                          );
                                        })}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>

                              </Grid>
                            </React.Fragment>
                            }
                            <Grid item xs={12}>

                              <SaveButton
                                      snackbarOpen={this.state.saveSnackbarOpen}
                                      autoHideDuration={this.state.saveSnackbarDuration}
                                      onSaveClick={() => { this._updateBusinessBeneficialOwner(biId, boId, dwollaCid); }}
                                      onSnackbarClose={() => { this._onSnackbarClose(); }}
                                      status={this.state.saveStatus}
                                      message={this.state.saveMessage}
                                      disabled={this.disableSave(props)}/>

                                { !this.showSpinner() && !dwollaOwnerid &&
                                  <Button variant="outlined" color="primary" style={AppBindStyles.bottomButton} onClick={() => { this.setState({confirmDelete:true}); }}>
                                    <Delete color="primary"/> Delete
                                  </Button>
                                }
                                <ConfirmationDialog
                                    open={this.state.confirmDelete}
                                    onClose={() => { this.setState({confirmDelete:false});}}
                                    onConfirm={() => { this._deleteBusinessBeneficialOwner(boId); }}
                                    onCancel={() => { }}
                                    irreversibleAction={true}
                                    title="Delete owner?"
                                    cancelBtn="Cancel"
                                    okBtn="Ok"
                                  >
                                    Are you sure you wish to delete this owner?
                                </ConfirmationDialog>  

                                {uploadDwollaAllowed &&
                                <Button color="primary" variant="outlined" style={AppBindStyles.bottomButton}
                                  disabled={!this.disableSave(props)}
                                  onClick={() => { this.goToDocumentUpload(biId, boId); }}
                                  >
                                  upload document
                                </Button>
                                }


                                {dwollaCid && sendDwollaAllowed && !this.showSecondarySpinner() &&
                                  <Button color="primary" variant="outlined" style={AppBindStyles.bottomButton}
                                    disabled={!this.disableSave(props)}
                                          onClick={() => {this.setState({confirmSend:true});}}>
                                    Send to ACH Partner
                                  </Button> 
                                }

                                {dwollaCid && (this.state.dwollaStatus !== 'verified') && this.showSecondarySpinner() &&
                                  <Button color="primary" variant="outlined" style={AppBindStyles.bottomButton}>
                                    <SavingSpinner/>
                                  </Button>
                                }
                                <ConfirmationDialog
                                    open={this.state.confirmSend}
                                    onClose={() => { this.setState({confirmSend:false});}}
                                    onConfirm={() => {this.sendDwollaInfo(boId, dwollaCid, dwollaOwnerid, props, biId) }}
                                    onCancel={() => { }}
                                    title="Confirm information?"
                                    cancelBtn="Cancel"
                                    okBtn="Ok"
                                    irreversibleAction={true}
                                  >
                                    If you proceed, the information will be sent to our ACH partner for verification.  You will no longer be able to delete or edit most information.  Is information complete?
                              </ConfirmationDialog>  

                            </Grid>
                          </Grid>
                        </Paper>
          
                      </div>
        
                    );
                  }
                }
                return <div><LoadingSpinner/></div>
              }}
            />
          );


       } else {
          return (
            <Redirect to='/home' />
          );
       }
    }

    _updateBusinessBeneficialOwner = (biId, boId, dwollaCid) => {

 
      this.setState({ showSpinner: true });
      const { ssn, dateOfBirth, passportNumber, passportCountry, 
        lastName, firstName, address1, address2, city, state, country, postalCode } = this.state;
      

      BusinessBeneficialOwnerUpdateMutation.commit(boId, ssn, dateOfBirth, passportNumber, passportCountry,
        lastName, firstName, address1, address2, city, state, country, postalCode, null, null)
      .then(response => {
        
        return null;
      })
      .then(response => {
        var count = this.state.forceFetch;
        count = count + 1;
        this.setState({ forceFetch: count, showSpinner: false, saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'Save successful.', saveSnackbarDuration: 3000 });

      })
      .catch(error => {
        this.setState({ showSpinner: false, saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Unable to save business owner.' });
        // this.goBack();
      });
    }

    _deleteBusinessBeneficialOwner = (boId) => {
      this.setState({ showSpinner: true });
      BusinessBeneficialOwnerDeleteMutation.commit(boId)
      .then(response => {
        this.setState({ showSpinner: false });
        this.goBack();
      })
      .catch(error => {
        this.setState({ showSpinner: false });
        this.goBack();
      });                      
    }
    _onSnackbarClose() {
      this.setState( {saveSnackbarOpen: false, saveStatus: '', saveMessage: '', saveSnackbarDuration: null });
    }

}

BusinessBeneficialOwnerEdit.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(BusinessBeneficialOwnerEdit);